import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { BaseService } from 'app/_helpers/base/base.service';
import { TranslateService } from '@ngx-translate/core';
import { filter, size, forEach, drop } from 'lodash';
import { startWith } from 'rxjs/operators';
import { AuthenticationService } from 'app/services';

@Component({
  selector: 'app-wg-residential-interest',
  templateUrl: './wg-residential-interest.component.html',
  styleUrls: ['./wg-residential-interest.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgResidentialInterestComponent implements OnInit {

  scheme: any;
  ranges: any;
  range: any;
  results = {} as any;
  filter = {} as any;
  systemLang: any;
  loadData = true as boolean;
  query: any;
  typeQuery: any;
  transaction: any;
  office: any;
  view: any[] = [200, 200];

  constructor(
    private _gService: BaseService,
    private _translateService: TranslateService,
    private _authenticationService: AuthenticationService
  ) {
    this.office = this._authenticationService.currentOfficeValue;
    this._translateService.onLangChange.pipe(startWith('')).subscribe(() => {
      this.systemLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
    });
    this.results = {
      transactions: [],
      propertyTypes: [],
      statuses: [],
      priceRanges: []
    };
    this.scheme = {
      domain: ['#ebe723', '#e08216', '#5c84f1', '#24e3e0', '#32a852', '#b02e7a']
    };
    this.ranges = {
      TW: this._translateService.instant('this_week'),
      TM: this._translateService.instant('this_month'),
      SM: this._translateService.instant('last_6_months'),
      TY: this._translateService.instant('this_year'),
    };
    this.range = 'TM';
  }

  ngOnInit(): void {
    this.getProperties();
  }

  getProperties(): void {
    this.results.transactions = [];
    this.results.propertyTypes = [];
    this.results.statuses = [];
    this.results.priceRanges = [];
    this._gService.post(`dashboard/residential_interest?range=${this.range}&type=transaction`, {}, 'nodejs').subscribe((data: any) => {
      this.results.transactions = [
        {
          name: this._translateService.instant('sale'),
          value: size(filter(data, 'sale')),
          extra: 'sale'
        },
        {
          name: this._translateService.instant('lt_rental'),
          value: size(filter(data, 'lt_rental')),
          extra: 'lt_rental'
        },
        {
          name: this._translateService.instant('st_rental'),
          value: size(filter(data, 'st_rental')),
          extra: 'st_rental'
        },
      ];
    });
    this.loadData = false;
  }

  onTransactionChange(data: any): void {
    this.results.propertyTypes = [];
    this.results.statuses = [];
    this.results.priceRanges = [];
    this.loadData = true;
    if (data.extra === 'sale') {
      this.query = { sale: true };
      this.transaction = 'sale';
    } else if (data.extra === 'lt_rental') {
      this.query = { lt_rental: true };
      this.transaction = 'lt_rental';
    } else {
      this.query = { st_rental: true };
      this.transaction = 'st_rental';
    }
    this.filter.query = this.query;
    this._gService.post(`dashboard/residential_interest?range=${this.range}&type=property_type`, this.filter, 'nodejs').subscribe((response: any) => {
      this.results.propertyTypes = [];
      if (response.length) {
        forEach(response, (value) => {
          const temp = {} as any;
          temp.value = value.count;
          temp.name = value._id.type[this.systemLang] ? value._id.type[this.systemLang] : value._id.type.en;
          temp.extra = value._id.key;
          this.results.propertyTypes.push(temp);
        });
      }
      this.loadData = false;
    });
  }

  onPropTypeChange(data: any): void {
    this.results.statuses = [];
    this.results.priceRanges = [];
    this.loadData = true;
    this.filter.query = {};
    this.filter.query.$and = [];
    this.typeQuery = { type_one: data.extra };
    this.filter.query.$and.push(this.query);
    this.filter.query.$and.push(this.typeQuery);
    this._gService.post(`dashboard/residential_interest?range=${this.range}&type=status`, this.filter, 'nodejs').subscribe((response: any) => {
      if (response.length) {
        this.results.statuses = response.map(({ _id, value }) => ({ name: _id, value }));
        forEach(this.results.statuses, (value) => {
          value.extra = value.name;
          value.name = value.name ? this._translateService.instant(value.name) : '';
        });
      }
      this.loadData = false;
    });
  }

  onStatusChange(data: any): void {
    this.results.priceRanges = [];
    this.loadData = true;
    this.filter.query = {};
    this.filter.query.$and = [];
    this.filter.query.$and = [{
      status: data.extra
    }];
    this.filter.query.$and.push(this.query);
    this.filter.query.$and.push(this.typeQuery);
    this._gService.post(`dashboard/residential_interest?range=${this.range}&type=price_range&transaction=${this.transaction}`, this.filter, 'nodejs').subscribe((response: any) => {
      if (response.length) {
        if (response[0]._id === '') {
          response = drop(response);
        }
        this.results.priceRanges = response.map(({ _id, value }) => ({ name: _id, value }));
        forEach(this.results.priceRanges, (value) => {
          value.name = `${value.name} - ${this.office.currency ? this.office.currency : 'EUR'}`;
        });
      }
      this.loadData = false;
    });
  }

}
